'use client';

import { XIcon } from 'lucide-react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLockBodyScroll } from 'react-use';
type Props = {
  children: React.ReactNode;
};

export default function CouponCopyDialog({ children }: Props) {
  const [el, setEl] = useState<HTMLElement | null>(null);
  const pathName = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  const couponId = searchParams.get('id');

  useLockBodyScroll();

  const handleClose = useCallback(() => {
    router.replace(pathName, { scroll: false });
  }, [router, pathName]);

  useEffect(() => {
    setEl(document.body);
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleClose]);

  if (!el || !couponId) return <></>;

  return createPortal(
    <div className="fixed inset-0 z-40 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-slate-800 opacity-50"
        onClick={handleClose}
      ></div>
      <div className="animate-in fade-in slide-in-from-bottom-20 relative flex h-full w-full bg-white md:h-4/5 md:max-w-[600px] md:rounded-3xl">
        <XIcon
          onClick={handleClose}
          className="absolute top-0 right-0 m-4 cursor-pointer"
        />
        {children}
      </div>
    </div>,
    el,
    couponId,
  );
}
